import * as rows from './rows';
import * as selection from './selection';
import * as expand from './expand';
import * as mutate from './mutate';
import * as sort from './sort';
import * as type from './type';

export default {
  ...rows,
  ...selection,
  ...expand,
  ...mutate,
  ...sort,
  ...type
};



// WEBPACK FOOTER //
// ./packages/react-bootstrap-table2/src/store/operators.js